// extracted by mini-css-extract-plugin
module.exports = {"root":"IconPending_root__21g7X"};